import { NgModule } from '@angular/core';
import { UiModule } from './ui/ui.module';
import { ComponentsModule } from './components/components.module';
// import { TranslateModule } from '@ngx-translate/core';
@NgModule({
    imports: [UiModule, ComponentsModule],
    exports: [UiModule, ComponentsModule],
})
export class SharedModule {}
